module.exports = __webpack_public_path__ + "img/08_1_2_1.43b8d580.png";